import React from 'react';
import PropTypes from 'prop-types';
import Flex from '@magalu/stereo-ui/atoms/Flex';
import Text from '@magalu/stereo-ui/atoms/Text';
import Button from '@magalu/stereo-ui/atoms/Button';
import { OpenLink } from '@magalu/stereo-ui-icons/build/icons';
var ShareLinksActionsError = function ShareLinksActionsError(_ref) {
  var errorStatus = _ref.errorStatus;
  return errorStatus === 401 ? React.createElement(Flex, {
    flexDirection: "column",
    alignItems: "center",
    gap: "10px"
  }, React.createElement(Text, {
    color: "error.text",
    lineHeight: "1.2"
  }, "Ops! Parece que voc\xEA precisa fazer login no admin novamente para continuar."), React.createElement(Button, {
    as: "a",
    variation: "outline",
    href: "/login",
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    endIcon: React.createElement(OpenLink, {
      width: 20,
      height: 20
    }),
    full: true
  }, "Ir para o login")) : React.createElement(Text, {
    color: "error.text",
    lineHeight: "1.2"
  }, "Poxa! Algo deu errado. Por favor, espere um pouquinho e tente de novo.");
};
export default ShareLinksActionsError;
process.env.NODE_ENV !== "production" ? ShareLinksActionsError.propTypes = {
  errorStatus: PropTypes.number.isRequired
} : void 0;